import {
  // @ts-expect-error Using experimental features
  // eslint-disable-next-line @wordpress/no-unsafe-wp-apis
  __experimentalToolsPanel as ToolsPanel,
  __experimentalToolsPanelItem as ToolsPanelItem,
  ToggleControl,
} from "@wordpress/components";
import { InspectorControls } from "@wordpress/block-editor";
import { __ } from "@wordpress/i18n";

/**
 * Compare Table Settings v2.0
 *
 * Note: Field selector removed in v2.0 - table now shows all attributes dynamically
 */
export default function Settings({ attributes, setAttributes }) {
  const { isPopup } = attributes;

  return (
    <InspectorControls>
      <ToolsPanel label={__("Settings", "brandy-blocks")}>
        <ToolsPanelItem
          label={__("Show in popup", "brandy-blocks")}
          hasValue={() => isPopup !== false}
          isShownByDefault
          onDeselect={() => {
            setAttributes({ isPopup: false });
          }}
        >
          <ToggleControl
            label={__("Show in popup", "brandy-blocks")}
            checked={!!isPopup}
            onChange={(value) => {
              setAttributes({ isPopup: value });
            }}
          />
        </ToolsPanelItem>
      </ToolsPanel>
    </InspectorControls>
  );
}
